import { render, staticRenderFns } from "./SearchHits.vue?vue&type=template&id=1ecb88f4"
import script from "./SearchHits.vue?vue&type=script&lang=ts"
export * from "./SearchHits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports